import React, { useEffect, useState } from 'react';
import MemberLayout from '../../components/MemberLayout';
import { getMyCases, createCase } from '../../services/api';

const STAGES = [
  'CASE_RECEIVED', 'CASE_REVIEW_COMPLETED', 'DOCUMENTS_PREPARED',
  'SUBMITTED', 'AWAITING_OUTCOME', 'FINALISED',
];

const STAGE_LABELS = {
  CASE_RECEIVED: 'Case Received',
  CASE_REVIEW_COMPLETED: 'Case Review Completed',
  DOCUMENTS_PREPARED: 'Documents Prepared',
  SUBMITTED: 'Submitted',
  AWAITING_OUTCOME: 'Awaiting Outcome',
  FINALISED: 'Finalised',
};

function CaseTimeline({ status }) {
  const currentIndex = STAGES.indexOf(status);
  return (
    <div className="timeline" style={{ marginTop: 16 }}>
      {STAGES.map((stage, i) => {
        const done = i < currentIndex;
        const current = i === currentIndex;
        return (
          <div className="timeline-step" key={stage}>
            <div className="timeline-marker">
              <div className={`timeline-dot ${done ? 'done' : ''} ${current ? 'current' : ''}`} />
              {i < STAGES.length - 1 && <div className={`timeline-line ${done ? 'done' : ''}`} />}
            </div>
            <div className="timeline-content">
              <h4>{STAGE_LABELS[stage]}</h4>
              {current && <p style={{ margin: 0, fontSize: '0.85rem', color: 'var(--color-gold)' }}>Current stage</p>}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default function MyCases() {
  const [cases, setCases] = useState([]);
  const [selected, setSelected] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ title: '', description: '' });
  const [loading, setLoading] = useState(false);

  const loadCases = () => {
    getMyCases().then((res) => setCases(res.data)).catch(() => {});
  };

  useEffect(() => { loadCases(); }, []);

  const handleCreate = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await createCase(form);
      setForm({ title: '', description: '' });
      setShowForm(false);
      loadCases();
    } finally {
      setLoading(false);
    }
  };

  return (
    <MemberLayout title="My Cases">
      <button className="btn btn-gold" onClick={() => setShowForm(!showForm)} style={{ marginBottom: 20 }}>
        {showForm ? 'Cancel' : 'Request Assistance / New Case'}
      </button>

      {showForm && (
        <form onSubmit={handleCreate} className="card" style={{ marginBottom: 24, maxWidth: 560 }}>
          <div className="form-group">
            <label>Matter Title</label>
            <input required value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} />
          </div>
          <div className="form-group">
            <label>Description</label>
            <textarea rows="4" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} />
          </div>
          <button className="btn btn-gold" disabled={loading}>{loading ? 'Submitting...' : 'Submit Case'}</button>
        </form>
      )}

      {cases.length === 0 ? (
        <p>You have no cases yet.</p>
      ) : (
        <div className="grid grid-2">
          {cases.map((c) => (
            <div className="card" key={c.id}>
              <h3>{c.title}</h3>
              <p style={{ fontSize: '0.85rem', color: 'var(--color-grey)' }}>{c.caseNumber}</p>
              <p>{c.description}</p>
              <button className="btn btn-outline-dark" onClick={() => setSelected(selected === c.id ? null : c.id)}>
                {selected === c.id ? 'Hide Timeline' : 'View Progress'}
              </button>
              {selected === c.id && <CaseTimeline status={c.status} />}
            </div>
          ))}
        </div>
      )}
    </MemberLayout>
  );
}
